import { AUTH_API, authFetch, getToken } from "./authApi";

function qs(params = {}) {
    const q = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null || value === "") continue;
        q.set(key, String(value));
    }

    const s = q.toString();
    return s ? `?${s}` : "";
}

export async function fetchManagerSeriesSeasons() {
    return authFetch("/api/manager/series-seasons", {
        method: "GET",
    });
}

export async function fetchManagerSeasonRaces(seasonId) {
    return authFetch(`/api/manager/seasons/${seasonId}/races`, {
        method: "GET",
    });
}

export async function fetchManagerDrivers(params = {}) {
    return authFetch(`/api/manager/drivers${qs(params)}`, {
        method: "GET",
    });
}

export async function updateManagerDriver(driverId, payload) {
    return authFetch(`/api/manager/drivers/${driverId}`, {
        method: "PATCH",
        body: JSON.stringify(payload),
    });
}

export async function updateManagerSeasonDriver(seasonDriverId, payload) {
    return authFetch(`/api/manager/season-drivers/${seasonDriverId}`, {
        method: "PATCH",
        body: JSON.stringify(payload),
    });
}

export async function createManagerSeasonDriver(payload) {
    return authFetch("/api/manager/season-drivers", {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export async function fetchManagerDiscordUsers(params = {}) {
    return authFetch(`/api/manager/discord-users${qs(params)}`, {
        method: "GET",
    });
}

export async function linkManagerDriverDiscord(driverId, discordUserId) {
    return authFetch(`/api/manager/drivers/${driverId}/link-discord`, {
        method: "POST",
        body: JSON.stringify({ discord_user_id: Number(discordUserId) }),
    });
}

export async function unlinkManagerDriverDiscord(driverId) {
    return authFetch(`/api/manager/drivers/${driverId}/link-discord`, {
        method: "DELETE",
    });
}

export async function fetchAdminSeasons(params = {}) {
    return authFetch(`/api/manager/admin/seasons${qs(params)}`, {
        method: "GET",
    });
}

export async function createAdminSeason(payload) {
    return authFetch("/api/manager/admin/seasons", {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export async function updateAdminSeason(seasonId, payload) {
    return authFetch(`/api/manager/admin/seasons/${seasonId}`, {
        method: "PATCH",
        body: JSON.stringify(payload),
    });
}

export async function activateAdminSeason(seasonId) {
    return authFetch(`/api/manager/admin/seasons/${seasonId}/activate`, {
        method: "POST",
    });
}

export async function archiveAdminSeason(seasonId) {
    return authFetch(`/api/manager/admin/seasons/${seasonId}/archive`, {
        method: "POST",
    });
}

export async function fetchAdminSeasonRuleset(seasonId) {
    return authFetch(`/api/manager/admin/seasons/${seasonId}/ruleset`, {
        method: "GET",
    });
}

export async function updateAdminSeasonRuleset(seasonId, payload) {
    return authFetch(`/api/manager/admin/seasons/${seasonId}/ruleset`, {
        method: "PUT",
        body: JSON.stringify(payload),
    });
}

export async function fetchAdminSeasonRaces(seasonId) {
    return authFetch(`/api/manager/admin/seasons/${seasonId}/races`, {
        method: "GET",
    });
}

export async function createAdminRace(seasonId, payload) {
    return authFetch(`/api/manager/admin/seasons/${seasonId}/races`, {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export async function updateAdminRace(raceId, payload) {
    return authFetch(`/api/manager/admin/races/${raceId}`, {
        method: "PATCH",
        body: JSON.stringify(payload),
    });
}

export async function deleteAdminRace(raceId) {
    return authFetch(`/api/manager/admin/races/${raceId}`, {
        method: "DELETE",
    });
}

export async function fetchAdminRoles() {
    return authFetch("/api/manager/admin/roles", {
        method: "GET",
    });
}

export async function fetchAdminUsers(params = {}) {
    return authFetch(`/api/manager/admin/users${qs(params)}`, {
        method: "GET",
    });
}

export async function updateAdminUserRoles(userId, roles) {
    return authFetch(`/api/manager/admin/users/${userId}/roles`, {
        method: "PATCH",
        body: JSON.stringify({ roles }),
    });
}

export async function linkAdminUserDriver(userId, driverId) {
    return authFetch(`/api/manager/admin/users/${userId}/link-driver`, {
        method: "POST",
        body: JSON.stringify({ driver_id: Number(driverId) }),
    });
}

export async function unlinkAdminUserDriver(userId) {
    return authFetch(`/api/manager/admin/users/${userId}/link-driver`, {
        method: "DELETE",
    });
}

export async function uploadManagerDriversCsv({ file, seriesKey = "gt3x", seasonId = "" }) {
    const token = getToken();
    if (!token) throw new Error("Kein Token gefunden - bitte neu einloggen.");

    const fd = new FormData();
    fd.append("file", file);
    fd.append("series_key", seriesKey);
    if (seasonId) fd.append("season_id", String(seasonId));

    const res = await fetch(`${AUTH_API}/api/manager/driver-import`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        body: fd,
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        throw new Error(data?.detail || data?.message || `HTTP ${res.status}`);
    }

    return data;
}
